import { CsError } from "../../../../../logic/CsError"
import { GenericPinErrorDialog } from "./GenericPinErrorDialog"
import { PinSessionEndedErrorDialog } from "./PinSessionEndedErrorDialog"

export function PinErrorDialogFallbacks({error} : { error: Error | CsError }) {
  if (error.cause === 'no_pin_token') {
    return (
      <PinSessionEndedErrorDialog/>
    )
  }
  return (
    <GenericPinErrorDialog error={ error } />
  )
}
